export * from './ProductDetailsTabs';
